
import {buildScaleFromSegments} from "./palette.js";

export function createAirdensPalette(resolution = 10) {

    const bounds = [0, 1.5];  // units: kg/m^3
    const segments = [
        [0,   [  0,   0,   0]],
        [1.5, [255, 255, 255]],
    ];
    return buildScaleFromSegments(bounds, segments, resolution);

}
